import { Box } from '@mui/joy';

import { CorporatePartPriceList } from 'corporate/components';
import { ICorporatePart } from 'corporate/types';
import { IExternalPricesResponse } from 'parts/types';

import { AlternatePrices } from './AlternatePrices';
import { PartDetailsTab } from '../enums';
import { usePartDetailsScrollToFocus } from '../hooks';

interface IProps {
  corporatePart: Partial<ICorporatePart>;
  partNumber: string;
  manufacturerId: number;
  externalPricing?: IExternalPricesResponse | null;
  isAlternateVersionEnabled?: boolean;
  enabled?: boolean;
  fullWidth?: boolean;
  isLoading?: boolean;
}

const MIN_ROWS_FOR_FOCUS_TRIGGER = 3;

export const Prices = ({
  corporatePart,
  partNumber,
  manufacturerId,
  externalPricing,
  isAlternateVersionEnabled,
  enabled,
  fullWidth,
  isLoading,
}: IProps) => {
  const { panelScrollAnchorRef, onBodyScroll } = usePartDetailsScrollToFocus(
    PartDetailsTab.PRICES,
    {
      minRowsForTrigger: MIN_ROWS_FOR_FOCUS_TRIGGER,
    }
  );

  if (isAlternateVersionEnabled) {
    return (
      <Box ref={panelScrollAnchorRef} sx={{ display: 'contents' }}>
        <AlternatePrices externalPricing={externalPricing} fullWidth={fullWidth} />
      </Box>
    );
  }

  return (
    <Box ref={panelScrollAnchorRef} sx={{ display: 'contents' }}>
      <CorporatePartPriceList
        enabled={enabled}
        corporatePart={corporatePart}
        partNumber={partNumber}
        manufacturerId={manufacturerId}
        fullWidth={fullWidth}
        isLoading={isLoading}
        onBodyScroll={onBodyScroll}
      />
    </Box>
  );
};
